import React from 'react';
import { Intent } from 'enums';
import { Button, ButtonLink } from '../../Button';
import {
  ModuleLoadingFallbackButtonGroup,
  ModuleLoadingFallbackContainer,
  ModuleLoadingFallbackPargraph,
  ModuleLoadingFallbackTitle,
} from './styles';

const isDev = process.env.NODE_ENV === ('development' || 'dev');

interface IFallback {
  error: Error;
  componentStack: string | null;
}

/**
 * Styled Error Fallback component passed to ErrorBoundary component
 * and rendered in case of a Module loading failure.
 *
 * Renders error message and stack trace in development environment.
 */
const ModuleLoadingFallback = ({
  error,
  componentStack,
}: IFallback): JSX.Element => (
  <ModuleLoadingFallbackContainer>
    <ModuleLoadingFallbackTitle>
      Oops, we can&apos;t load this page
    </ModuleLoadingFallbackTitle>
    <ModuleLoadingFallbackPargraph>
      We have been notified of this issue and will look into it as soon as
      possible.
    </ModuleLoadingFallbackPargraph>
    <ModuleLoadingFallbackPargraph>
      This can sometimes be fixed with a simple refresh, but if you require
      further assistance, please contact support.
    </ModuleLoadingFallbackPargraph>
    <ModuleLoadingFallbackButtonGroup>
      <Button intent={Intent.PRIMARY} onClick={() => window.location.reload()}>
        Refresh Page
      </Button>
      <ButtonLink intent={Intent.NONE} design="text" to="/get-in-touch">
        Contact Support
      </ButtonLink>
    </ModuleLoadingFallbackButtonGroup>
    {isDev && (
      <>
        <ModuleLoadingFallbackPargraph>
          {error.toString()}
        </ModuleLoadingFallbackPargraph>
        <ModuleLoadingFallbackPargraph>
          {componentStack}
        </ModuleLoadingFallbackPargraph>
      </>
    )}
  </ModuleLoadingFallbackContainer>
);

export default ModuleLoadingFallback;
